import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import Tooltip from "@material-ui/core/Tooltip";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism.css";

import Header from '../layout/Header';
import Footer from '../layout/Footer';
import Sidebar from '../layout/Sidebar';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import '../../scss/broadcast.scss';
import { parseBreadcrumbsList } from '../../store/Actions';
import getResponse from '../actions/Project';
import RefreshToken from '../actions/RefreshToken';
import htmlpreview from '../../images/project/html-preview.png';
import publicpreview from '../../images/project/public-preview.png';
import upload from '../../images/project/publish.png';
import Snackbars from '../Reusables/Snackbar';

function Broadcast(props) {
    const {id} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [enable, setEnable] = useState(false);
    const [idBroadcast, setIdBroadcast] = useState(null);
    const [draftMessage, setDraftMessage] = useState("");
    const [publicMessage,setPublicMessage] = useState("");
    const [status, setStatus] = useState(null);
    const [savedDraftMessage, setSavedDraftMessage] = useState(null);
    const [previewTemplate, setPreviewTemplate] = useState(null);
    const [trigger, setTrigger] = useState(false);
    const [projectName, setProjectName] = useState('');
    // const [enablePublicPreview, setEnablePublicPreview] = useState(false);
    const [enableHtmlPreview, setEnableHtmlPreview] = useState(false);
    const [enablePublish, setEnablePublish] = useState(false);
    const [open, setOpen] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [severity, setSeverity] = useState("")
    const [published, setPublished] = useState(null);

    useEffect(() => {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                const URL = `/api/Project/projectdetails/${id}`;
                getResponse.GetProjectDetails(URL, accesstoken, (response) => {  
                    if(response.status == 200) {
                        if(response.data != null) {
                            setProjectName(response.data.name)
                            if(response.data.broadcasts != null && response.data.broadcasts.length > 0) {
                                setIdBroadcast(response.data.broadcasts[0].idBroadcast)
                                setTrigger(!trigger);
                            }
                            var breadcrumbsList = [
                                { "name": "Home", "url": "" },
                                { "name": "Projects", "url": "projects/list" },
                                { "name": `${response.data.name}`, "url": `projects/${id}/view` },
                                { "name": "Broadcast", "url": `projects/${id}/broadcast` },
                            ];
                            dispatch(parseBreadcrumbsList(breadcrumbsList));
                        }
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }, [])

    useEffect(() => {
        if(idBroadcast != null) {
            function CallAPI(accesstoken) {
                if(accesstoken === '') {
                    navigate('/login');
                } else {
                    const URL = `/api/project/broadcastdetails/${idBroadcast}`;
                    getResponse.GetProjectDetails(URL, accesstoken, (response) => {  
                        if(response.status == 200) {
                            setDraftMessage(decodeURIComponent(response.data.draftMessage));
                            setPublicMessage(response.data.publicMessage);
                            setStatus(response.data.status);
                            setSavedDraftMessage(response.data.draftMessage);
                            setPublished(response.data.published);
                        } else if(response.status == 401) {
                            navigate("/login")
                        }
                    });
                }
            }
            RefreshToken((accesstoken) => CallAPI(accesstoken));
        }
    }, [trigger])

    // useEffect(() => {
    //     if(status == "Published") {
    //         setEnablePublicPreview(true);
    //     }
    // }, [status])

    useEffect(() => {
        if(savedDraftMessage != null && savedDraftMessage != '') {
            setEnableHtmlPreview(true);
            setEnablePublish(true);
        }
    }, [savedDraftMessage])

    const publishMessage = () => {
        if(idBroadcast != null && savedDraftMessage != null && savedDraftMessage != "") {
            handleBroadcastApi('publish');
        }
    }

    const uploadFiles = () => {
        navigate(`/projects/${id}/broadcast/files`)
        var breadcrumbsList = [
            { "name": "Home", "url": "" },
            { "name": "Projects", "url": "projects/list" },
            { "name": `${projectName}`, "url": `projects/${id}/view` },
            { "name": "Broadcast", "url": `projects/${id}/broadcast` },
            { "name": "Files", "url": `projects/${id}/broadcast/files` },
        ];
        dispatch(parseBreadcrumbsList(breadcrumbsList));
    }

    const hightlightWithLineNumbers = (input, language) =>
        highlight(input, language)
            .split("\n")
            .map((line, i) => `<span class='editorLineNumber'>${i + 1}</span>${line}`)
            .join("\n");

    const handleBroadcast = () => {
        handleBroadcastApi('draft');
    }

    const handleBroadcastApi = (type) => {
        var data = null;
        var URL = null;
        if(type == 'draft') {
            if(idBroadcast == null && draftMessage != null && draftMessage != "") {
                setEnable(false);
                data = {
                    ProjectId: id,
                    DraftMessage: encodeURIComponent(draftMessage)
                }
                URL = '/api/project/addbroadcast';
            } else if (idBroadcast != null && draftMessage != null && draftMessage != "") {
                setEnable(false);
                data = {
                    IdBroadcast: idBroadcast,
                    ProjectId: id,
                    DraftMessage : draftMessage,
                    PublicMessage: publicMessage
                }
                URL = `/api/project/editbroadcast/${idBroadcast}`;
            }
        } else {
            setEnable(false);
            data = {
                IdBroadcast: idBroadcast,
                ProjectId: id,
                DraftMessage : savedDraftMessage,
                PublicMessage: savedDraftMessage
            }
            URL = `/api/project/editbroadcast/${idBroadcast}`;
        }

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            } else {
                getResponse.CreatePost(data, accesstoken, URL, (response) => {  
                    if(response.status == 200) {
                        // setEnable(true);
                        setIdBroadcast(response.data.details.broadcastId);
                        setTrigger(!trigger)
                        if(type == 'draft') {
                            setOpen(true);
                            setSeverity("success")
                            setSuccessMessage("Saved successfully");
                        } else {
                            setOpen(false);
                            window.open(`${response.data.details.publicUrl}`, '_blank')
                        }
                    } else if(response.status == 401) {
                        navigate("/login")
                    } else {
                        setEnable(true);
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const handleDraftMessage = (message) => {
        setDraftMessage(message);
    }

    useEffect(() => {
        if(draftMessage != null && draftMessage != "" && draftMessage != decodeURIComponent(savedDraftMessage)) {
            console.log("Draft Messages ", draftMessage, savedDraftMessage)
            setEnable(true);
        } else {
            setEnable(false);
        }
    }, [draftMessage, savedDraftMessage])

    const handleSnackbar = (value) => {
        setOpen(value);

        if(severity == "success") {
            if(!published) {
                setOpen(true);
                setSeverity("warning")
                setSuccessMessage("Changes yet to be published")
            }
        }
    }

    useEffect(() => {
        if(severity == "" && published != null && !published) {
            setOpen(true);
            setSeverity("warning")
            setSuccessMessage("Changes yet to be published")
        }
    }, [published])

    return (
        <div className='broadcast-container'>
            <Header />

            <div className='row broadcast-sub-container'>
                <Sidebar />

                <div className='col-10 broadcast-content'>
                    <Breadcrumbs />

                    <div className='broadcast-header'>
                        <div className='header-container'>
                            <div className='header-text'>HTML Editor</div>
                            <div className='actions'>
                                <div className='save-button'>
                                    <button disabled={enable ? false : true} className={enable ? 'add-button enable' : 'add-button disable'} onClick={handleBroadcast}>Save Draft</button>
                                </div>
                                <Tooltip title="Draft Preview">
                                    <div className={enableHtmlPreview ? 'enableAnchor' : 'disableAnchor'}>
                                        <a href={`${process.env.REACT_APP_CC_BASE_URL}/broadcast/draft/${projectName}/${idBroadcast}`} target="_blank">
                                            <img src={htmlpreview} alt="htmlpreview"></img>
                                        </a>
                                    </div>
                                </Tooltip> 
                                <Tooltip title="Publish">
                                    <div className={enablePublish ? 'enableAnchor' : 'disableAnchor'}>
                                        {/* <a href={`${process.env.REACT_APP_CC_BASE_URL}/broadcast/public/${projectName}/${idBroadcast}`} target="_blank">
                                            <img src={publicpreview} alt="publicpreview"></img>
                                        </a> */}
                                        <img src={publicpreview} alt="publicpreview" onClick={publishMessage}></img>
                                    </div>
                                </Tooltip> 
                                <Tooltip title="Upload Files">
                                    <div className='enableAnchor'>
                                        <img src={upload} alt="upload" onClick={uploadFiles}></img>
                                    </div>
                                </Tooltip> 
                            </div>
                        </div>
                    </div>
                    <div className='html-editor'>
                        <Editor
                            value={draftMessage}
                            onValueChange={message => handleDraftMessage(message)}
                            highlight={code => hightlightWithLineNumbers(code, languages.js)}
                            padding={10}
                            textareaId="codeArea"
                            className="editor"
                            style={{
                                fontFamily: 'Lato-Regular',
                                fontSize: 18,
                                outline: 0,
                            }}
                        />
                    </div>
                </div>
            </div>

            <Footer /> 

            <Snackbars error="" open={open} setOpen={(value) => handleSnackbar(value)} severity={severity} message={successMessage}/>
        </div>
    );
}

export default Broadcast;